module.exports = __webpack_public_path__ + "img/mj_kefu2.22a1c55d.png";